import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useCustomTranslations } from '../../../../hooks/useCustomTranslations';
import { RegistrationField } from '../../../../interfaces/interfaces';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { RegistrationFormFieldProps } from '../RegistrationFormField';
import { useTranslation } from 'next-i18next';

interface RegistrationCheckboxInterface
  extends Pick<RegistrationFormFieldProps, 'field' | 'defaultValue' | 'disabled' | 'color' | 'showFieldLabel' | 'checkboxColor'> {
  isRequired: (field: RegistrationField) => boolean;
  onChange?: (key: string, value: string) => void;
}

const RegistrationCheckbox = ({
  field: registrationField,
  defaultValue,
  disabled,
  color,
  isRequired,
  checkboxColor,
  showFieldLabel,
  onChange,
}: RegistrationCheckboxInterface) => {
  const event = useSelector((state) => state.common.event);

  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { ct } = useCustomTranslations();
  const { t } = useTranslation();

  const label = registrationField.label ? ct(registrationField.label, registrationField, 'labelTranslations') : '';

  return (
    <>
      <Controller
        control={control}
        name={registrationField._id}
        defaultValue={defaultValue ?? 'false'}
        rules={{
          validate: (value) => {
            if (isRequired(registrationField)) return value?.toString() === 'true' || t('form:fieldrequired');
          },
        }}
        render={({ field }) => (
          <FormControlLabel
            sx={{
              '& .MuiFormControlLabel-asterisk': {
                display: 'none',
              },
            }}
            control={
              <Checkbox
                inputRef={field.ref}
                name={field.name}
                onBlur={field.onBlur}
                onChange={(e: any) => {
                  if (onChange) onChange(registrationField._id, e.target.checked);
                  field.onChange(e.target.checked?.toString());
                }}
                style={{ color: color || event?.template?.mainColor }}
                disabled={disabled}
                checked={field.value === 'true'}
                color="primary"
              />
            }
            label={
              <div
                className="text-base"
                style={{ fontFamily: event?.template.customFont ?? 'Gilroy !important' }}
                dangerouslySetInnerHTML={{
                  __html: `${label}${isRequired(registrationField) ? ' *' : ''}`,
                }}
              />
            }
          />
        )}
      />
      <p className="text-xs text-[#FF1744] mx-[14px] font-sans">{errors[registrationField._id]?.message?.toString()}</p>
    </>
  );
};
export default RegistrationCheckbox;
